export default __webpack_public_path__ + "static/bottomBanner-6fbada2c3a99bbde3bd2bde2d3312040.png";